import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { createPersistentStorage } from '../../../lib/persistentStorage'
import type { RegistrationDraft, SegmentId } from '../../product-segment'
import type { OnboardingPayload } from './types'
import { draftVariant, type OnboardingVariant } from './onboardingVariant'
export interface OnboardingDraft extends RegistrationDraft { ownerUserId: string | null; answers: OnboardingPayload & Record<string, unknown> }
interface DraftState {
  draft: OnboardingDraft | null
  ensure: (segment: SegmentId, scenarioId: string, version: number, ownerUserId: string | null, variant?: OnboardingVariant) => OnboardingDraft
  update: (id: string, answers: OnboardingPayload) => void
  markReady: (id: string) => void
  clear: (id?: string) => void
}
export const useDraftStore = create<DraftState>()(persist((set, get) => ({
  draft: null,
  ensure: (segment, scenarioId, version, ownerUserId, variant = 'default') => {
    const current = get().draft
    if (current?.segment === segment && current.scenarioId === scenarioId && current.version === version && current.ownerUserId === ownerUserId && draftVariant(current.answers) === variant) return current
    const draft: OnboardingDraft = { id: crypto.randomUUID(), segment, scenarioId, version, ownerUserId, answers: variant === 'quiz' ? { custom: { variant } } : {}, readyToSubmit: false }
    set({ draft })
    return draft
  },
  update: (id, answers) => { const draft = get().draft; if (draft?.id === id) set({ draft: { ...draft, answers: structuredClone(answers), readyToSubmit: false } }) },
  markReady: (id) => { const draft = get().draft; if (draft?.id === id) set({ draft: { ...draft, readyToSubmit: true } }) },
  clear: (id) => { if (!id || get().draft?.id === id) set({ draft: null }) },
}), { name: 'humanteq-onboarding-draft', storage: createPersistentStorage() }))
